import cx from "classnames";
import React, { useCallback, useEffect, useState } from "react";
import parse from 'html-react-parser';

import { Dispatch, TableCell as TableCellType } from "../../types";
import { convertHtmlToInnodom, convertInnodomToHtml } from "./TextEditor";
import { Editor } from 'react-draft-wysiwyg';
import { ContentState, convertToRaw, EditorState } from "draft-js";

import './TableCell.scss';
import FontVariant from "./FontVariant";
import draftToHtml from "./draftToHtml";
import htmlToDraft from "./html-to-draftjs"

type Props = Readonly<{
  active: boolean;
  blockId: string;
  cell: TableCellType;
  dispatch: Dispatch;
}>;

export const TableCell = ({ blockId, cell, dispatch, active }: Props) => {
  const [editorState, setEditorState] = useState<EditorState>(EditorState.createEmpty());

  const setEditorReference = (ref) => {
    if (ref) {
      setTimeout(() => ref.focus(), 10)
    }
  }

  const onChange = useCallback(
    e => {
      dispatch({
        blockId,
        cellId: cell.id,
        text: e.target.value,
        type: "UPDATE CELL TEXT",
      });
    },
    [cell.id, dispatch],
  );

  useEffect(() => {

    if (active) {

      const blocksFromHtml = htmlToDraft(convertInnodomToHtml(cell.text));
      const { contentBlocks, entityMap } = blocksFromHtml;
      const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
      const editorState = EditorState.createWithContent(contentState);

      setEditorState(editorState);
    }
  }, [active]);

  const editorClassName = cx("editor-text", {
    invalid: !cell.validXml,
  });
  return (
    <div>
      {!active && 
      <div 
        className = "unselected-cell"
        onClick={(e)=> {
          e.preventDefault();
          dispatch({
            type:"MARK CELL ACTIVE",
            cellId:cell.id
          });
        }}
      >{parse(convertInnodomToHtml(cell.text))}
      </div>}
    {active && <Editor
      editorState={editorState}
      editorRef={setEditorReference}
      wrapperClassName="wrapper-class cell"
      editorClassName="editor-class"
      toolbarClassName="toolbar-class"
      customStyleMap={{
        'SMALLCAPS' : {
          fontVariant: 'small-caps'
        }
      }}
      toolbarCustomButtons={[
          <FontVariant
            editorState={editorState}
            onChange={(state)=> {setEditorState(state)}}
          ></FontVariant>
      ]}
      onTab={(e) => {
        e.stopPropagation();
        if (e.shiftKey) {
          dispatch({
            reverse: true,
            type: "NEXT ACTIVE BLOCK",
          });
        } else {
          dispatch({
            reverse: false,
            type: "NEXT ACTIVE BLOCK",
          });
        }
      }}
      onEditorStateChange={(e: EditorState) => {
        setEditorState(e);
        dispatch({
          blockId: blockId,
          cellId: cell.id,
          text: convertHtmlToInnodom(draftToHtml(convertToRaw(e.getCurrentContent()))),
          type: "UPDATE CELL TEXT",
        });
      }}
    />}
    </div>
  );
};
TableCell.displayName = "TableCell";
